export const setActiveTreatmentTabForPatient = (
	key: string,
	patientId: string,
	workplaceId: string,
) => {
	let activeTabs = JSON.parse(
		localStorage.getItem('activeTreatmentTab') ?? '[]',
	);
	if (!activeTabs) {
		activeTabs = [];
	}
	const tabsToKeep = activeTabs.filter(
		m => m.patientId !== patientId || m.workplaceId !== workplaceId,
	);
	localStorage.setItem(
		'activeTreatmentTab',
		JSON.stringify([
			...tabsToKeep,
			{
				key: key,
				patientId: patientId,
				workplaceId: workplaceId,
			},
		]),
	);
};

export const getActiveTreatmentTabForPatient = (
	patientId: string,
	workplaceId: string,
) => {
	const activeTabs = JSON.parse(
		localStorage.getItem('activeTreatmentTab') ?? '[]',
	);
	if (activeTabs) {
		const tab = activeTabs.find(
			m => m.patientId === patientId && m.workplaceId === workplaceId,
		);
		if (tab) {
			return tab?.key;
		}
	}
	return null;
};
